import { render, staticRenderFns } from "./Tournament.vue?vue&type=template&id=64202f66&scoped=true&"
import script from "./Tournament.vue?vue&type=script&lang=js&"
export * from "./Tournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64202f66",
  null
  
)

export default component.exports